<card-expanding
  [formGroup]="form"
  [valid]="cardValidType"
  [expanded]="isExpanded"
  (onExpand)="saveLocalExpandedValue($event)"
>
  <span header-title>{{ title | translate}}</span>

  <div header-actions *requiredRights="[UserAction.ManageProducts]">
    <ng-container *ngIf="isOwnProduct">
      <locked-info *ngIf="!edit && locked" [locked]="locked"></locked-info>
      <ng-container *ngIf="!edit && !locked">
        <lxm-button
          type="beige"
          icon="edit"
          title="action.edit"
          (click)="toggleEdit()"
        ></lxm-button>
      </ng-container>
      <ng-container *ngIf="edit">
        <lxm-button
          *ngIf="edit"
          type="grey"
          icon="back"
          label="action.cancel"
          (click)="toggleEdit()"
        >
        </lxm-button>
        <lxm-button
          *ngIf="edit"
          type="beige"
          icon="save"
          label="action.save"
          [loading]="saveLoading"
          (click)="save()"
          buttonType="submit"
        ></lxm-button>
      </ng-container>
    </ng-container>
  </div>

  <div body>
    <card-section>
      <div class="row">
        <div class="col-6 no-padding">
          <form-field
            [readonly]="!edit"
            label="cards.products.product_certificate_info_and_nutrition_info.label.label_languages"
            description="cards.products.product_certificate_info_and_nutrition_info.label_description.label_languages"
            for="labelLanguages"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.LabelLanguages, form.get('labelLanguages').value?.length > 0)"
          >
            <lxm-select
              select
              for="labelLanguages"
              [readonly]="!edit"
              labelField="name"
              [multiple]="true"
              [searchable]="true"
              [options]="selectedLabelLanguages"
              url="api/clvac/languages/"
              class="w-full"
            >
            </lxm-select>
            <validation-errors for="labelLanguages"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_certificate_info_and_nutrition_info.label.ethicality"
            description="cards.products.product_certificate_info_and_nutrition_info.label_description.ethicality"
            for="ethicalMarkingId"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.EthicalMarking, form.get('ethicalMarkingId').value)"
          >
            <lxm-select
              select
              for="ethicalMarkingId"
              value="id"
              labelField="value"
              [readonly]="!edit"
              [sortByLabel]="true"
              [searchable]="true"
              [multiple]="true"
              [options]="ethicalMarkings"
              class="w-full"
            ></lxm-select>
            <validation-errors for="ethicalMarkingId"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_certificate_info_and_nutrition_info.label.product_characteristics"
            description="cards.products.product_certificate_info_and_nutrition_info.label_description.product_characteristics"
            for="productCharacteristicsIds"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.ProductCharacteristics, form.get('productCharacteristicsIds').value)"
          >
            <lxm-select
              select
              for="productCharacteristicsIds"
              value="id"
              labelField="translatedValue"
              [isTranslated]="true"
              [readonly]="!edit"
              [sortByLabel]="true"
              [searchable]="true"
              [multiple]="true"
              [options]="productCharacteristicsOptions"
              class="w-full"
            ></lxm-select>
            <validation-errors
              for="productCharacteristicsIds"
            ></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_certificate_info_and_nutrition_info.label.identification_marking"
            description="cards.products.product_certificate_info_and_nutrition_info.label_description.identification_marking"
            for="identificationMarkingId"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.IdentificationMarking, form.get('identificationMarkingId').value)"
          >
            <lxm-select
              select
              for="identificationMarkingId"
              value="id"
              labelField="value"
              [readonly]="!edit"
              [sortByLabel]="true"
              [searchable]="true"
              [options]="identificationMarkingOptions"
              class="w-full"
            ></lxm-select>
            <validation-errors
              for="identificationMarkingId"
            ></validation-errors>
          </form-field>
          
          <form-field
            [readonly]="!edit"
            label="cards.products.product_certificate_info_and_nutrition_info.label.food_safety_certificates"
            description="cards.products.product_certificate_info_and_nutrition_info.label_description.food_safety_certificates"
            for="foodSafetyCertificateIds"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.FoodSafetyCertificates, form.get('foodSafetyCertificateIds').value)"
          >
            <lxm-select
              select
              for="foodSafetyCertificateIds"
              value="id"
              labelField="value"
              [readonly]="!edit"
              [sortByLabel]="true"
              [searchable]="true"
              [multiple]="true"
              [options]="foodSafetyCertificateOptions"
              class="w-full"
            ></lxm-select>
            <validation-errors
              for="foodSafetyCertificateIds"
            ></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_certificate_info_and_nutrition_info.label.contaminant_info"
            description="cards.products.product_certificate_info_and_nutrition_info.label_description.contaminant_info"
            for="contaminantInfoIds"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.ContaminantInfo, form.get('contaminantInfoIds').value)"
          >
            <lxm-select
              select
              for="contaminantInfoIds"
              value="id"
              labelField="value"
              [readonly]="!edit"
              [sortByLabel]="true"
              [searchable]="true"
              [multiple]="true"
              [options]="contaminantInfoOptions"
              class="w-full"
            ></lxm-select>
            <validation-errors
              for="contaminantInfoIds"
            ></validation-errors>
          </form-field>
        </div>

        <div class="col-6 no-padding">
          <form-field
            [readonly]="!edit"
            label="cards.products.product_certificate_info_and_nutrition_info.label.eco_friendly"
            description="cards.products.product_certificate_info_and_nutrition_info.label_description.eco_friendly"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.EcoFriendly, form.get('ecoFriendly').value)"
          >
            <slide-toggle
              toggle
              for="ecoFriendly"
              [readonly]="!edit"
            ></slide-toggle>
            <validation-errors for="ecoFriendly"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_certificate_info_and_nutrition_info.label.healthy_option"
            description="cards.products.product_certificate_info_and_nutrition_info.label_description.healthy_option"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.HealthyOption, form.get('healthyOption').value)"
          >
            <slide-toggle
              toggle
              for="healthyOption"
              [readonly]="!edit"
            ></slide-toggle>
            <validation-errors for="healthyOption"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_certificate_info_and_nutrition_info.label.allergy_free"
            description="cards.products.product_certificate_info_and_nutrition_info.label_description.allergy_free"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.AllergySealOfApproval, form.get('allergySealOfApproval').value)"
          >
            <slide-toggle
              toggle
              for="allergySealOfApproval"
              [readonly]="!edit"
            ></slide-toggle>
            <validation-errors for="allergySealOfApproval"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_certificate_info_and_nutrition_info.label.sensitive"
            description="cards.products.product_certificate_info_and_nutrition_info.label_description.sensitive"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Sensitive, form.get('sensitive').value)"
          >
            <slide-toggle
              toggle
              for="sensitive"
              [readonly]="!edit"
            ></slide-toggle>
            <validation-errors for="sensitive"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_certificate_info_and_nutrition_info.label.paraben_free"
            description="cards.products.product_certificate_info_and_nutrition_info.label_description.paraben_free"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.ParabenFree, form.get('parabenFree').value)"
          >
            <slide-toggle
              toggle
              for="parabenFree"
              [readonly]="!edit"
            ></slide-toggle>
            <validation-errors for="parabenFree"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_certificate_info_and_nutrition_info.label.odorless"
            description="cards.products.product_certificate_info_and_nutrition_info.label_description.odorless"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Odorless, form.get('odorless').value)"
          >
            <slide-toggle
              toggle
              for="odorless"
              [readonly]="!edit"
            ></slide-toggle>
            <validation-errors for="odorless"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_certificate_info_and_nutrition_info.label.alcohol_free"
            description="cards.products.product_certificate_info_and_nutrition_info.label_description.alcohol_free"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.AlcoholFree, form.get('alcoholFree').value)"
          >
            <slide-toggle
              toggle
              for="alcoholFree"
              [readonly]="!edit"
            ></slide-toggle>
            <validation-errors for="alcoholFree"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_certificate_info_and_nutrition_info.label.grain_free"
            description="cards.products.product_certificate_info_and_nutrition_info.label_description.grain_free"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.GrainFree, form.get('grainFree').value)"
            *ngIf="showGrainFree"
          >
            <slide-toggle
              toggle
              for="grainFree"
              [readonly]="!edit"
            ></slide-toggle>
            <validation-errors for="grainFree"></validation-errors>
          </form-field>
        </div>
      </div>

      <div class="separator"></div>

      <div class="row">
        <div class="col-12 no-padding">
          <form-field
            [readonly]="!edit"
            label="cards.products.product_certificate_info_and_nutrition_info.label.ingredients"
            description="cards.products.product_certificate_info_and_nutrition_info.label_description.ingredients"
            for="ingredients"
            [validationResultType]="productValidity.isRequiredByRetailerLanguageText(productField.Ingredients)"
          >
            <language-text
              language-text
              for="ingredients"
              [readonly]="!edit"
              [newline]="true"
              [validationResultType]="productValidity.getLanguageTextRequiredTypes(productField.Ingredients)"
            >
            </language-text>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_certificate_info_and_nutrition_info.label.microbiological_requirements"
            description="cards.products.product_certificate_info_and_nutrition_info.label_description.microbiological_requirements"
            for="microbiologicalRequirementIds"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.MicrobiologicalRequirements, form.get('microbiologicalRequirementIds').value)"
          >
            <lxm-select
              select
              for="microbiologicalRequirementIds"
              value="id"
              labelField="translatedValue"
              [isTranslated]="true"
              [readonly]="!edit"
              [sortByLabel]="true"
              [searchable]="true"
              [multiple]="true"
              [options]="microbiologicalRequirementOptions"
              class="w-full"
            ></lxm-select>
            <validation-errors
              for="microbiologicalRequirementIds"
            ></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_certificate_info_and_nutrition_info.label.chili_heat_scale"
            description="cards.products.product_certificate_info_and_nutrition_info.label_description.chili_heat_scale"
            for="chiliHeatScaleId"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.ChiliHeatScale, form.get('chiliHeatScaleId').value)"
          >
            <lxm-select
              select
              for="chiliHeatScaleId"
              value="id"
              labelField="value"
              [readonly]="!edit"
              [sortByLabel]="true"
              [searchable]="true"
              [options]="chiliHeatScaleOptions"
              class="w-full"
            ></lxm-select>
            <validation-errors for="chiliHeatScaleId"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_certificate_info_and_nutrition_info.label.allergen_free"
            description="cards.products.product_certificate_info_and_nutrition_info.label_description.allergen_free"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.AllergenFree, form.get('allergenFree').value)"
          >
            <slide-toggle
              toggle
              for="allergenFree"
              [readonly]="!edit"
            ></slide-toggle>
            <validation-errors for="allergenFree"></validation-errors>
          </form-field>
        </div>
      </div>
    </card-section>

    <section-expanding
      [expanded]="true"
      class="mt0"
      [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.ProductAllergens, form.get('allergens').value?.length > 0)"
    >
      <span header-title>
        {{'cards.products.product_certificate_info_and_nutrition_info.product_allergens.title'
        | translate}}
      </span>
      <div body class="overflow-x w-full">
        <product-allergens-list
          for="allergens"
          [readonly]="!edit"
          [allergenOptions]="allergenOptions"
        >
        </product-allergens-list>
      </div>
    </section-expanding>

    <div class="separator"></div>

    <section-expanding [expanded]="shouldExpandSections">
      <span header-title>
        {{'cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.title'
        | translate}}
      </span>
      <div body>
        <div class="row">
          <div class="col-6 no-padding">
            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.natural"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.natural"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Natural, form.get('natural').value)"
            >
              <slide-toggle
                toggle
                for="natural"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="natural"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.gmo_content"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.gmo_content"
              for="gmoContentId"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.GmoContent, form.get('gmoContentId').value)"
            >
              <lxm-select
                select
                for="gmoContentId"
                class="w-full"
                style="min-width: 200px"
                value="id"
                labelField="translatedValue"
                [isTranslated]="true"
                [readonly]="!edit"
                [options]="gmoContentOptions"
              >
              </lxm-select>
              <validation-errors for="gmoContentId"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.label.irradiation_type"
              description="cards.products.product_certificate_info_and_nutrition_info.label_description.irradiation_type"
              for="irradiationTypeId"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.IrradiationType, form.get('irradiationTypeId').value)"
            >
              <lxm-select
                select
                for="irradiationTypeId"
                value="id"
                labelField="value"
                [readonly]="!edit"
                [sortByLabel]="true"
                [searchable]="true"
                [options]="irradiationTypeOptions"
                class="w-full"
              ></lxm-select>
              <validation-errors for="irradiationTypeId"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.additive_free"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.additive_free"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.AdditiveFree, form.get('additiveFree').value)"
            >
              <slide-toggle
                toggle
                for="additiveFree"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="additiveFree"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.enriched_with_protein"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.enriched_with_protein"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.EnrichedWithProtein, form.get('enrichedWithProtein').value)"
            >
              <slide-toggle
                toggle
                for="enrichedWithProtein"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="enrichedWithProtein"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.enriched_with_vitamins"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.enriched_with_vitamins"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.EnrichedWithVitamins, form.get('enrichedWithVitamins').value)"
            >
              <slide-toggle
                toggle
                for="enrichedWithVitamins"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="enrichedWithVitamins"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.soy_based"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.soy_based"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.SoyBased, form.get('soyBased').value)"
            >
              <slide-toggle
                toggle
                for="soyBased"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="soyBased"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.yeast_free"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.yeast_free"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.YeastFree, form.get('yeastFree').value)"
            >
              <slide-toggle
                toggle
                for="yeastFree"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="yeastFree"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.no_added_yeast"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.no_added_yeast"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.NoAddedYeast, form.get('noAddedYeast').value)"
            >
              <slide-toggle
                toggle
                for="noAddedYeast"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="noAddedYeast"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.vegan"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.vegan"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.SuitableForVegans, form.get('suitableForVegans').value)"
            >
              <slide-toggle
                toggle
                for="suitableForVegans"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="suitableForVegans"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.vegetarian"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.vegetarian"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.SuitableForVegetarians, form.get('suitableForVegetarians').value)"
            >
              <slide-toggle
                toggle
                for="suitableForVegetarians"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors
                for="suitableForVegetarians"
              ></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.egg_free"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.egg_free"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.EggFree, form.get('eggFree').value)"
            >
              <slide-toggle
                toggle
                for="eggFree"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="eggFree"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.lactose_reduced"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.lactose_reduced"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.LactoseContentReduced, form.get('lactoseContentReduced').value)"
            >
              <slide-toggle
                toggle
                for="lactoseContentReduced"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors
                for="lactoseContentReduced"
              ></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.lactose_free"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.lactose_free"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.LactoseFree, form.get('lactoseFree').value)"
            >
              <slide-toggle
                toggle
                for="lactoseFree"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="lactoseFree"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.dairy_free"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.dairy_free"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.DairyFree, form.get('dairyFree').value)"
            >
              <slide-toggle
                toggle
                for="dairyFree"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="dairyFree"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.dairy_type"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.dairy_type"
              for="dairyTypeId"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.DairyType, form.get('dairyTypeId').value)"
            >
              <lxm-select
                select
                class="w-full"
                for="dairyTypeId"
                [readonly]="!edit"
                [options]="dairyTypes"
                value="id"
                labelField="translatedValue"
                [isTranslated]="true"
              ></lxm-select>
              <validation-errors for="dairyType"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.calorie_reduced"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.calorie_reduced"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.ReducedEnergyFood, form.get('reducedEnergyFood').value)"
            >
              <slide-toggle
                toggle
                for="reducedEnergyFood"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="reducedEnergyFood"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.calorie_low"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.calorie_low"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.LowCalorie, form.get('lowCalorie').value)"
            >
              <slide-toggle
                toggle
                for="lowCalorie"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="lowCalorie"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.calorie_free"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.calorie_free"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.CalorieFree, form.get('calorieFree').value)"
            >
              <slide-toggle
                toggle
                for="calorieFree"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="calorieFree"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.gluten_low"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.gluten_low"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.LowGluten, form.get('lowGluten').value)"
            >
              <slide-toggle
                toggle
                for="lowGluten"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="lowGluten"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.gluten_free"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.gluten_free"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.GlutenFree, form.get('glutenFree').value)"
            >
              <slide-toggle
                toggle
                for="glutenFree"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="glutenFree"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.fiber"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.fiber"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.SourceOfFiber, form.get('sourceOfFiber').value)"
            >
              <slide-toggle
                toggle
                for="sourceOfFiber"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="sourceOfFiber"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.fiber_high"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.fiber_high"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.HighFiber, form.get('highFiber').value)"
            >
              <slide-toggle
                toggle
                for="highFiber"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="highFiber"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.protein"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.protein"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.SourceOfProtein, form.get('sourceOfProtein').value)"
            >
              <slide-toggle
                toggle
                for="sourceOfProtein"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="sourceOfProtein"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.protein_high"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.protein_high"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.HighProtein, form.get('highProtein').value)"
            >
              <slide-toggle
                toggle
                for="highProtein"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="highProtein"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.meat_content_increased"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.meat_content_increased"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.MeatContentIncreased, form.get('meatContentIncreased').value)"
            >
              <slide-toggle
                toggle
                for="meatContentIncreased"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="meatContentIncreased"></validation-errors>
            </form-field>
          </div>
          <div class="col-6 no-padding">
            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.sugar_reduced"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.sugar_reduced"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.ReducedSugarFood, form.get('reducedSugarFood').value)"
            >
              <slide-toggle
                toggle
                for="reducedSugarFood"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="reducedSugarFood"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.sugar_low"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.sugar_low"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.LowSugar, form.get('lowSugar').value)"
            >
              <slide-toggle
                toggle
                for="lowSugar"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="lowSugar"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.sugar_free"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.sugar_free"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.SugarFree, form.get('sugarFree').value)"
            >
              <slide-toggle
                toggle
                for="sugarFree"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="sugarFree"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.sugar_not_added"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.sugar_not_added"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.NoAddedSugar, form.get('noAddedSugar').value)"
            >
              <slide-toggle
                toggle
                for="noAddedSugar"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="noAddedSugar"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.sodium_low"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.sodium_low"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.LowSodium, form.get('lowSodium').value)"
            >
              <slide-toggle
                toggle
                for="lowSodium"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="lowSodium"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.sodium_very_low"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.sodium_very_low"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.VeryLowSodium, form.get('veryLowSodium').value)"
            >
              <slide-toggle
                toggle
                for="veryLowSodium"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="veryLowSodium"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.sodium_free"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.sodium_free"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.SodiumFree, form.get('sodiumFree').value)"
            >
              <slide-toggle
                toggle
                for="sodiumFree"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="sodiumFree"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.sodium_not_added"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.sodium_not_added"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.NoAddedSodium, form.get('noAddedSodium').value)"
            >
              <slide-toggle
                toggle
                for="noAddedSodium"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="noAddedSodium"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.monounsaturated_fat_high"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.monounsaturated_fat_high"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.HighInMonounsaturatedFattyAcid, form.get('highInMonounsaturatedFattyAcid').value)"
            >
              <slide-toggle
                toggle
                for="highInMonounsaturatedFattyAcid"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors
                for="highInMonounsaturatedFattyAcid"
              ></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.polyunsaturated_fat_high"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.polyunsaturated_fat_high"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.HighInPolyunsaturatedFattyAcid, form.get('highInPolyunsaturatedFattyAcid').value)"
            >
              <slide-toggle
                toggle
                for="highInPolyunsaturatedFattyAcid"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors
                for="highInPolyunsaturatedFattyAcid"
              ></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.unsaturated_fat_high"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.unsaturated_fat_high"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.HighInUnsaturatedFattyAcid, form.get('highInUnsaturatedFattyAcid').value)"
            >
              <slide-toggle
                toggle
                for="highInUnsaturatedFattyAcid"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors
                for="highInUnsaturatedFattyAcid"
              ></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.saturated_fat_reduced"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.saturated_fat_reduced"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.ReducedSaturatedFat, form.get('reducedSaturatedFat').value)"
            >
              <slide-toggle
                toggle
                for="reducedSaturatedFat"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="reducedSaturatedFat"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.saturated_fat_low"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.saturated_fat_low"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.LowSaturatedFat, form.get('lowSaturatedFat').value)"
            >
              <slide-toggle
                toggle
                for="lowSaturatedFat"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="lowSaturatedFat"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.saturated_fat_free"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.saturated_fat_free"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.SaturatedFatFree, form.get('saturatedFatFree').value)"
            >
              <slide-toggle
                toggle
                for="saturatedFatFree"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="saturatedFatFree"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.fat_low"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.fat_low"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.LowFat, form.get('lowFat').value)"
            >
              <slide-toggle
                toggle
                for="lowFat"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="lowFat"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.fat_free"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.fat_free"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.FatFree, form.get('fatFree').value)"
            >
              <slide-toggle
                toggle
                for="fatFree"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="fatFree"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.light"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.light"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.LightOrLite, form.get('lightOrLite').value)"
            >
              <slide-toggle
                toggle
                for="lightOrLite"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="lightOrLite"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.omega3"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.omega3"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.SourceOfOmega3, form.get('sourceOfOmega3').value)"
            >
              <slide-toggle
                toggle
                for="sourceOfOmega3"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="sourceOfOmega3"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.omega3_high"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.omega3_high"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Omega3Rich, form.get('omega3Rich').value)"
            >
              <slide-toggle
                toggle
                for="omega3Rich"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="omega3Rich"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.palm_oil_free"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.palm_oil_free"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.PalmOilFree, form.get('palmOilFree').value)"
            >
              <slide-toggle
                toggle
                for="palmOilFree"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="palmOilFree"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.rspo_certified_palm_oil"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.rspo_certified_palm_oil"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.RspoCertifiedPalmOil, form.get('rspoCertifiedPalmOil').value)"
            >
              <slide-toggle
                toggle
                for="rspoCertifiedPalmOil"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="rspoCertifiedPalmOil"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.is_organic"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.is_organic"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.IsOrganic, form.get('isOrganic').value)"
            >
              <slide-toggle
                toggle
                for="isOrganic"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="isOrganic"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.is_biodynamic"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.is_biodynamic"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.IsBiodynamic, form.get('isBiodynamic').value)"
            >
              <slide-toggle
                toggle
                for="isBiodynamic"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="isBiodynamic"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label.no_added_sulphites"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutritional_claims.label_description.no_added_sulphites"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.NoAddedSulphites, form.get('noAddedSulphites').value)"
            >
              <slide-toggle
                toggle
                for="noAddedSulphites"
                [readonly]="!edit"
              ></slide-toggle>
              <validation-errors for="noAddedSulphites"></validation-errors>
            </form-field>
          </div>
        </div>
      </div>
    </section-expanding>

    <section-expanding [expanded]="shouldExpandSections">
      <span header-title
        >{{'cards.products.product_certificate_info_and_nutrition_info.product_nutrition_facts.title'
        | translate}}</span
      >
      <div body>
        <div class="row">
          <div class="col-6 no-padding">
            <!-- description="cards.products.product_certificate_info_and_nutrition_info.product_nutrition_facts.label_description.nutrition_energy_kj" -->
            <form-field
              [readonly]="!edit"
              for="energy_kJ"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutrition_facts.label.nutrition_energy_kj"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Energy_kJ, form.get('energy_kJ').value)"
              [ngSwitch]="edit"
            >
              <div class="flex w-full items-center gap-1" *ngSwitchCase="true">
                <lxm-select
                  select
                  for="energy_kJ_Operator"
                  style="min-width: 80px; width: 80px"
                  value="id"
                  [readonly]="!edit"
                  [options]="comparisonOperatorShortOptions"
                  labelField="name"
                >
                </lxm-select>
                <lxm-input
                  for="energy_kJ"
                  [readonly]="!edit"
                  type="number"
                  class="w-full"
                ></lxm-input>
              </div>

              <div class="input-padding flex" *ngSwitchCase="false">
                <ng-container *ngIf="form.value.energy_kJ_Operator">
                  {{getComparisonOperatorNameById(form.value.energy_kJ_Operator)
                  | translate}}
                </ng-container>
                {{form.value.energy_kJ}}
              </div>

              <validation-errors for="energy_kJ"></validation-errors>
            </form-field>

            <!-- description="cards.products.product_certificate_info_and_nutrition_info.product_nutrition_facts.label_description.nutrition_energy_kcal" -->
            <form-field
              [readonly]="!edit"
              for="energy_kcal"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutrition_facts.label.nutrition_energy_kcal"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Energy_kcal, form.get('energy_kcal').value)"
              [ngSwitch]="edit"
            >
              <div class="flex w-full gap-1" *ngSwitchCase="true">
                <lxm-select
                  select
                  for="energy_kcal_Operator"
                  style="min-width: 80px; width: 80px"
                  value="id"
                  [readonly]="!edit"
                  [options]="comparisonOperatorShortOptions"
                  labelField="name"
                >
                </lxm-select>
                <lxm-input
                  for="energy_kcal"
                  [readonly]="!edit"
                  type="number"
                  class="w-full"
                ></lxm-input>
              </div>

              <div class="input-padding flex" *ngSwitchCase="false">
                <ng-container *ngIf="form.value.energy_kcal_Operator">
                  {{getComparisonOperatorNameById(form.value.energy_kcal_Operator)
                  | translate}}
                </ng-container>
                {{form.value.energy_kcal}}
              </div>

              <validation-errors for="energy_kcal"></validation-errors>
            </form-field>

            <!-- description="cards.products.product_certificate_info_and_nutrition_info.product_nutrition_facts.label_description.nutrition_total_carbohydrate" -->
            <form-field
              [readonly]="!edit"
              for="totalCarbohydrate_g"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutrition_facts.label.nutrition_total_carbohydrate"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.TotalCarbohydrate_g, form.get('totalCarbohydrate_g').value)"
              [ngSwitch]="edit"
            >
              <div class="flex w-full gap-1" *ngSwitchCase="true">
                <lxm-select
                  select
                  for="totalCarbohydrate_Operator"
                  style="min-width: 80px; width: 80px"
                  value="id"
                  [readonly]="!edit"
                  [options]="comparisonOperatorShortOptions"
                  labelField="name"
                >
                </lxm-select>
                <lxm-input
                  for="totalCarbohydrate_g"
                  [readonly]="!edit"
                  type="number"
                  class="w-full"
                ></lxm-input>
              </div>
              <div class="input-padding flex" *ngSwitchCase="false">
                <ng-container *ngIf="form.value.totalCarbohydrate_Operator">
                  {{getComparisonOperatorNameById(form.value.totalCarbohydrate_Operator)
                  | translate}}
                </ng-container>
                {{form.value.totalCarbohydrate_g}}
              </div>
              <validation-errors for="totalCarbohydrate_g"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              for="totalSugars_g"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutrition_facts.label.nutrition_sugars"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutrition_facts.label_description.nutrition_sugars"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.TotalSugars_g, form.get('totalSugars_g').value)"
              [ngSwitch]="edit"
            >
              <div class="flex w-full gap-1" *ngSwitchCase="true">
                <lxm-select
                  select
                  for="totalSugars_Operator"
                  style="min-width: 80px; width: 80px"
                  value="id"
                  [readonly]="!edit"
                  [options]="comparisonOperatorShortOptions"
                  labelField="name"
                >
                </lxm-select>
                <lxm-input
                  for="totalSugars_g"
                  [readonly]="!edit"
                  type="number"
                  class="w-full"
                ></lxm-input>
              </div>
              <div class="input-padding flex" *ngSwitchCase="false">
                <ng-container *ngIf="form.value.totalSugars_Operator">
                  {{getComparisonOperatorNameById(form.value.totalSugars_Operator)
                  | translate}}
                </ng-container>
                {{form.value.totalSugars_g}}
              </div>
              <validation-errors for="totalSugars_g"></validation-errors>
            </form-field>

            <!-- description="cards.products.product_certificate_info_and_nutrition_info.product_nutrition_facts.label_description.nutrition_protein" -->
            <form-field
              [readonly]="!edit"
              for="protein_g"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutrition_facts.label.nutrition_protein"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Protein_g, form.get('protein_g').value)"
            >
              <lxm-input
                for="protein_g"
                [readonly]="!edit"
                type="number"
                class="w-full"
              ></lxm-input>
              <validation-errors for="protein_g"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              for="sodium_g"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutrition_facts.label.nutrition_sodium"
              description="cards.products.product_certificate_info_and_nutrition_info.product_nutrition_facts.label_description.nutrition_sodium"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Sodium_g, form.get('sodium_g').value)"
            >
              <lxm-input
                for="sodium_g"
                [readonly]="!edit"
                type="number"
                class="w-full"
              ></lxm-input>
              <validation-errors for="sodium_g"></validation-errors>
            </form-field>

            <!-- description="cards.products.product_certificate_info_and_nutrition_info.product_nutrition_facts.label_description.nutrition_total_fat" -->
            <form-field
              [readonly]="!edit"
              for="totalFat_g"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutrition_facts.label.nutrition_total_fat"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.TotalFat_g, form.get('totalFat_g').value)"
            >
              <lxm-input
                for="totalFat_g"
                [readonly]="!edit"
                type="number"
                class="w-full"
              ></lxm-input>
              <validation-errors for="totalFat_g"></validation-errors>
            </form-field>
          </div>
          <div class="col-6 no-padding">
            <!-- description="cards.products.product_certificate_info_and_nutrition_info.product_nutrition_facts.label_description.nutrition_saturated_fat" -->
            <form-field
              [readonly]="!edit"
              for="saturatedFat_g"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutrition_facts.label.nutrition_saturated_fat"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.SaturatedFat_g, form.get('saturatedFat_g').value)"
            >
              <lxm-input
                for="saturatedFat_g"
                [readonly]="!edit"
                type="number"
                class="w-full"
              ></lxm-input>
              <validation-errors for="saturatedFat_g"></validation-errors>
            </form-field>

            <!-- description="cards.products.product_certificate_info_and_nutrition_info.product_nutrition_facts.label_description.nutrition_monounsaturated_fat" -->
            <form-field
              [readonly]="!edit"
              for="monounsaturatedFat_g"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutrition_facts.label.nutrition_monounsaturated_fat"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.MonounsaturatedFat_g, form.get('monounsaturatedFat_g').value)"
            >
              <lxm-input
                for="monounsaturatedFat_g"
                [readonly]="!edit"
                type="number"
                class="w-full"
              ></lxm-input>
              <validation-errors for="monounsaturatedFat_g"></validation-errors>
            </form-field>

            <!-- description="cards.products.product_certificate_info_and_nutrition_info.product_nutrition_facts.label_description.nutrition_polyunsaturated_fat" -->
            <form-field
              [readonly]="!edit"
              for="polyunsaturatedFat_g"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutrition_facts.label.nutrition_polyunsaturated_fat"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.PolyunsaturatedFat_g, form.get('polyunsaturatedFat_g').value)"
            >
              <lxm-input
                for="polyunsaturatedFat_g"
                [readonly]="!edit"
                type="number"
                class="w-full"
              ></lxm-input>
              <validation-errors for="polyunsaturatedFat_g"></validation-errors>
            </form-field>

            <!-- description="cards.products.product_certificate_info_and_nutrition_info.product_nutrition_facts.label_description.nutrition_polyols" -->
            <form-field
              [readonly]="!edit"
              for="sugarAlcohol_g"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutrition_facts.label.nutrition_polyols"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.SugarAlcohol_g, form.get('sugarAlcohol_g').value)"
            >
              <lxm-input
                for="sugarAlcohol_g"
                [readonly]="!edit"
                type="number"
                class="w-full"
              ></lxm-input>
              <validation-errors for="sugarAlcohol_g"></validation-errors>
            </form-field>

            <!-- description="cards.products.product_certificate_info_and_nutrition_info.product_nutrition_facts.label_description.nutrition_starch" -->
            <form-field
              [readonly]="!edit"
              for="starch_g"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutrition_facts.label.nutrition_starch"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Starch_g, form.get('starch_g').value)"
            >
              <lxm-input
                for="starch_g"
                [readonly]="!edit"
                type="number"
                class="w-full"
              ></lxm-input>
              <validation-errors for="starch_g"></validation-errors>
            </form-field>

            <!-- description="cards.products.product_certificate_info_and_nutrition_info.product_nutrition_facts.label_description.nutrition_dietary_fiber" -->
            <form-field
              [readonly]="!edit"
              for="dietaryFiber_g"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutrition_facts.label.nutrition_dietary_fiber"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.DietaryFiber_g, form.get('dietaryFiber_g').value)"
            >
              <lxm-input
                for="dietaryFiber_g"
                [readonly]="!edit"
                type="number"
                class="w-full"
              ></lxm-input>
              <validation-errors for="dietaryFiber_g"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              for="lactose_g"
              label="cards.products.product_certificate_info_and_nutrition_info.product_nutrition_facts.label.nutrition_lactose"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Lactose_g, form.get('lactose_g').value)"
            >
              <lxm-input
                for="lactose_g"
                [readonly]="!edit"
                type="number"
                class="w-full"
              ></lxm-input>
              <validation-errors for="lactose_g"></validation-errors>
            </form-field>
          </div>
        </div>
      </div>
    </section-expanding>

    <section-expanding [expanded]="shouldExpandSections">
      <span header-title
        >{{'cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.title'
        | translate}}</span
      >
      <div body>
        <div class="row">
          <div class="col-6 no-padding">
            <form-field
              [readonly]="!edit"
              for="vitaminA_mcg"
              label="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label.nutrition_vitamin_a"
              type="input-text"
              description="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label_description.nutrition_vitamin_k"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.VitaminA_mcg, form.get('vitaminA_mcg').value)"
            >
              <validation-errors for="vitaminA_mcg"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              for="vitaminC_mg"
              label="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label.nutrition_vitamin_c"
              type="input-text"
              description="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label_description.nutrition_vitamin_c"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.VitaminC_mg, form.get('vitaminC_mg').value)"
            >
              <validation-errors for="vitaminC_mg"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              for="vitaminD_mcg"
              label="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label.nutrition_vitamin_d"
              type="input-text"
              description="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label_description.nutrition_vitamin_d"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.VitaminD_mcg, form.get('vitaminD_mcg').value)"
            >
              <validation-errors for="vitaminD_mcg"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              for="vitaminE_mg"
              label="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label.nutrition_vitamin_e"
              type="input-text"
              description="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label_description.nutrition_vitamin_e"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.VitaminE_mg, form.get('vitaminE_mg').value)"
            >
              <validation-errors for="vitaminE_mg"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              for="vitaminK_mcg"
              label="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label.nutrition_vitamin_k"
              type="input-text"
              description="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label_description.nutrition_vitamin_k"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.VitaminK_mcg, form.get('vitaminK_mcg').value)"
            >
              <validation-errors for="vitaminK_mcg"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              for="vitaminB6_mg"
              label="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label.nutrition_vitamin_b6"
              type="input-text"
              description="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label_description.nutrition_vitamin_b6"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.VitaminB6_mg, form.get('vitaminB6_mg').value)"
            >
              <validation-errors for="vitaminB6_mg"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              for="vitaminB12_mcg"
              label="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label.nutrition_vitamin_b12"
              type="input-text"
              description="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label_description.nutrition_vitamin_b12"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.VitaminB12_mcg, form.get('vitaminB12_mcg').value)"
            >
              <validation-errors for="vitaminB12_mcg"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              for="biotin_mcg"
              label="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label.nutrition_biotin"
              type="input-text"
              description="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label_description.nutrition_biotin"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Biotin_mcg, form.get('biotin_mcg').value)"
            >
              <validation-errors for="biotin_mcg"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              for="fluoride_mg"
              label="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label.nutrition_fluoride"
              type="input-text"
              description="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label_description.nutrition_fluoride"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Fluoride_mg, form.get('fluoride_mg').value)"
            >
              <validation-errors for="fluoride_mg"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              for="folicAcid_mcg"
              label="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label.nutrition_folic_acid"
              type="input-text"
              description="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label_description.nutrition_folic_acid"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.FolicAcid_mcg, form.get('folicAcid_mcg').value)"
            >
              <validation-errors for="folicAcid_mcg"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              for="phosphorus_mg"
              label="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label.nutrition_phosphorus"
              type="input-text"
              description="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label_description.nutrition_phosphorus"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Phosphorus_mg, form.get('phosphorus_mg').value)"
            >
              <validation-errors for="phosphorus_mg"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              for="iodine_mcg"
              label="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label.nutrition_iodine"
              type="input-text"
              description="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label_description.nutrition_iodine"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Iodine_mcg, form.get('iodine_mcg').value)"
            >
              <validation-errors for="iodine_mcg"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              for="potassium_mg"
              label="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label.nutrition_potassium"
              type="input-text"
              description="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label_description.nutrition_potassium"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Potassium_mg, form.get('potassium_mg').value)"
            >
              <validation-errors for="potassium_mg"></validation-errors>
            </form-field>
          </div>
          <div class="col-6 no-padding">
            <form-field
              [readonly]="!edit"
              for="calcium_mg"
              label="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label.nutrition_kaltsium"
              type="input-text"
              description="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label_description.nutrition_kaltsium"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Calcium_mg, form.get('calcium_mg').value)"
            >
              <validation-errors for="calcium_mg"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              for="chromium_mcg"
              label="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label.nutrition_chromium"
              type="input-text"
              description="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label_description.nutrition_chromium"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Chromium_mcg, form.get('chromium_mcg').value)"
            >
              <validation-errors for="chromium_mcg"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              for="magnesium_mg"
              label="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label.nutrition_magnesium"
              type="input-text"
              description="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label_description.nutrition_magnesium"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Magnesium_mg, form.get('magnesium_mg').value)"
            >
              <validation-errors for="magnesium_mg"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              for="manganese_mg"
              label="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label.nutrition_manganese"
              type="input-text"
              description="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label_description.nutrition_manganese"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Manganese_mg, form.get('manganese_mg').value)"
            >
              <validation-errors for="manganese_mg"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              for="molybdenum_mcg"
              label="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label.nutrition_molybdenum"
              type="input-text"
              description="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label_description.nutrition_molybdenum"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Molybdenum_mcg, form.get('molybdenum_mcg').value)"
            >
              <validation-errors for="molybdenum_mcg"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              for="niacin_mg"
              label="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label.nutrition_niacin"
              type="input-text"
              description="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label_description.nutrition_niacin"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Niacin_mg, form.get('niacin_mg').value)"
            >
              <validation-errors for="niacin_mg"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              for="pantothenicAcid_mg"
              label="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label.nutrition_pantothenicacid"
              type="input-text"
              description="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label_description.nutrition_pantothenicacid"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.PantothenicAcid_mg, form.get('pantothenicAcid_mg').value)"
            >
              <validation-errors for="pantothenicAcid_mg"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              for="iron_mg"
              label="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label.nutrition_iron"
              type="input-text"
              description="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label_description.nutrition_iron"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Iron_mg, form.get('iron_mg').value)"
            >
              <validation-errors for="iron_mg"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              for="riboflavin_mg"
              label="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label.nutrition_riboflavin"
              type="input-text"
              description="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label_description.nutrition_riboflavin"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Riboflavin_mg, form.get('riboflavin_mg').value)"
            >
              <validation-errors for="riboflavin_mg"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              for="selenium_mcg"
              label="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label.nutrition_selenium"
              type="input-text"
              description="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label_description.nutrition_selenium"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Selenium_mcg, form.get('selenium_mcg').value)"
            >
              <validation-errors for="selenium_mcg"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              for="thiamin_mg"
              label="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label.nutrition_thiamin"
              type="input-text"
              description="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label_description.nutrition_thiamin"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Thiamin_mg, form.get('thiamin_mg').value)"
            >
              <validation-errors for="thiamin_mg"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              for="zinc_mg"
              label="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label.nutrition_zinc"
              type="input-text"
              description="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label_description.nutrition_zinc"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Zinc_mg, form.get('zinc_mg').value)"
            >
              <validation-errors for="zinc_mg"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              for="copper_mg"
              label="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label.nutrition_copper"
              type="input-text"
              description="cards.products.product_certificate_info_and_nutrition_info.product_vitamins_minerals.label_description.nutrition_copper"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Copper_mg, form.get('copper_mg').value)"
            >
              <validation-errors for="copper_mg"></validation-errors>
            </form-field>
          </div>
        </div>
      </div>
    </section-expanding>

    <section-expanding [expanded]="shouldExpandSections">
      <span header-title
        >{{
        'cards.products.product_certificate_info_and_nutrition_info.product_organoleptic_indicators.title'
        | translate }}</span
      >
      <div body>
        <div class="row">
          <div class="col-6 no-padding">
            <form-field
              for="appearance"
              type="input-text"
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_organoleptic_indicators.label.appearance"
              description="cards.products.product_certificate_info_and_nutrition_info.product_organoleptic_indicators.label_description.appearance"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Appearance, form.get('appearance').value)"
            >
              <validation-errors for="appearance"></validation-errors>
            </form-field>
          </div>
          <div class="col-6 no-padding">
            <form-field
              for="taste"
              type="input-text"
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_organoleptic_indicators.label.taste"
              description="cards.products.product_certificate_info_and_nutrition_info.product_organoleptic_indicators.label_description.taste"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Taste, form.get('taste').value)"
            >
              <validation-errors for="taste"></validation-errors>
            </form-field>
          </div>
        </div>
      </div>
    </section-expanding>

    <section-expanding [expanded]="shouldExpandSections">
      <span header-title
        >{{
        'cards.products.product_certificate_info_and_nutrition_info.product_physico_chemical_indicators.title'
        | translate }}</span
      >
      <div body>
        <div class="row">
          <div class="col-6 no-padding">
            <form-field
              for="nitrite"
              type="input-text"
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_physico_chemical_indicators.label.nitrite"
              description="cards.products.product_certificate_info_and_nutrition_info.product_physico_chemical_indicators.label_description.nitrite"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Nitrite, form.get('nitrite').value)"
            >
              <validation-errors for="nitrite"></validation-errors>
            </form-field>

            <form-field
              for="phosphorusPentoxide"
              type="input-text"
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_physico_chemical_indicators.label.phosphorus_pentoxide"
              description="cards.products.product_certificate_info_and_nutrition_info.product_physico_chemical_indicators.label_description.phosphorus_pentoxide"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.PhosphorusPentoxide, form.get('phosphorusPentoxide').value)"
            >
              <validation-errors for="phosphorusPentoxide"></validation-errors>
            </form-field>

            <form-field
              for="dryMatterContent"
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_physico_chemical_indicators.label.dry_matter_content"
              description="cards.products.product_certificate_info_and_nutrition_info.product_physico_chemical_indicators.label_description.dry_matter_content"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.DryMatterContent, form.get('dryMatterContent').value)"
            >
              <lxm-input
                for="dryMatterContent"
                [readonly]="!edit"
                type="number"
                class="w-full"
              ></lxm-input>
              <validation-errors for="dryMatterContent"></validation-errors>
            </form-field>

            <form-field
              for="fatContent"
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_physico_chemical_indicators.label.fat_content"
              description="cards.products.product_certificate_info_and_nutrition_info.product_physico_chemical_indicators.label_description.fat_content"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.FatContent, form.get('fatContent').value)"
            >
              <lxm-input
                for="fatContent"
                [readonly]="!edit"
                type="number"
                class="w-full"
              ></lxm-input>
              <validation-errors for="fatContent"></validation-errors>
            </form-field>
          </div>
          <div class="col-6 no-padding">
            <form-field
              for="ph"
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_physico_chemical_indicators.label.ph"
              description="cards.products.product_certificate_info_and_nutrition_info.product_physico_chemical_indicators.label_description.ph"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Ph, form.get('ph').value)"
            >
              <lxm-input
                for="ph"
                [readonly]="!edit"
                type="number"
                class="w-full"
              ></lxm-input>
              <validation-errors for="ph"></validation-errors>
            </form-field>

            <form-field
              for="acidity"
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_physico_chemical_indicators.label.acidity"
              description="cards.products.product_certificate_info_and_nutrition_info.product_physico_chemical_indicators.label_description.acidity"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Acidity, form.get('acidity').value)"
            >
              <lxm-input
                for="acidity"
                [readonly]="!edit"
                type="number"
                class="w-full"
              ></lxm-input>
              <validation-errors for="acidity"></validation-errors>
            </form-field>

            <form-field
              for="lactoseContent"
              [readonly]="!edit"
              label="cards.products.product_certificate_info_and_nutrition_info.product_physico_chemical_indicators.label.lactose_content"
              description="cards.products.product_certificate_info_and_nutrition_info.product_physico_chemical_indicators.label_description.lactose_content"
              [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.LactoseContent, form.get('lactoseContent').value)"
            >
              <lxm-input
                for="lactoseContent"
                [readonly]="!edit"
                type="number"
                class="w-full"
              ></lxm-input>
              <validation-errors for="lactoseContent"></validation-errors>
            </form-field>
          </div>
        </div>
      </div>
    </section-expanding>
  </div>

  <div footer class="flex flex-row" *ngIf="edit">
    <lxm-button
      class="ml15"
      type="grey"
      icon="back"
      label="action.cancel"
      (click)="toggleEdit()"
    ></lxm-button>
    <lxm-button
      class="ml15"
      type="beige"
      icon="save"
      label="action.save"
      [loading]="saveLoading"
      (click)="save()"
    >
    </lxm-button>
  </div>
</card-expanding>
